import ptBRLocale from 'date-fns/locale/pt-BR'

export const weekDays = [...Array(7).keys()].map(i => ptBRLocale.localize.day(i, { width: 'short' }))
